import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';

interface FooterLink {
  label: string;
  href: string;
  newTab?: boolean;
}

const RAKENNUSTIETO_SITE = 'https://www.rakennustieto.fi';

/** Site footer copied from the parent Rakennustieto site (www.rakennustieto.fi/fi). */
@Component({
  selector: 'app-site-footer',
  imports: [NgOptimizedImage, NgTemplateOutlet],
  templateUrl: './site-footer.component.html',
  styleUrl: './site-footer.component.scss',
})
export class SiteFooterComponent {
  protected readonly homeUrl = `${RAKENNUSTIETO_SITE}/fi`;

  protected readonly legalLinks: FooterLink[] = [
    { label: 'Tietosuojaseloste', href: `${RAKENNUSTIETO_SITE}/tietosuojaseloste` },
    { label: 'Käyttölupahakemus', href: 'https://www.rts.fi/kayttolupahakemus', newTab: true },
    {
      label: 'Yleiset sopimusehdot',
      href: `${RAKENNUSTIETO_SITE}/yleiset-sopimusehdot`,
      newTab: true,
    },
    {
      label: 'Esteettömyysseloste',
      href: 'https://tiedostot.rakennustieto.fi/Esteetto%CC%88myysseloste%20Rakennustieto.pdf',
      newTab: true,
    },
  ];

  protected readonly quickLinks: FooterLink[] = [
    { label: 'Palvelut', href: `${RAKENNUSTIETO_SITE}/fi/palvelut` },
    { label: 'Ajankohtaista', href: `${RAKENNUSTIETO_SITE}/fi/ajankohtaista` },
    { label: 'Kirjakauppa', href: 'https://www.rakennustietokauppa.fi' },
    { label: 'Yritys', href: `${RAKENNUSTIETO_SITE}/fi/yritys` },
    { label: 'Materiaalipankki', href: `${RAKENNUSTIETO_SITE}/fi/materiaalipankki` },
  ];

  protected readonly contactLinks: FooterLink[] = [
    { label: 'Ota yhteyttä', href: `${RAKENNUSTIETO_SITE}/fi/yhteystiedot` },
    { label: 'Asiakastuki', href: 'https://asiakastuki.rakennustieto.fi' },
    { label: 'Ura Rakennustiedossa', href: 'https://ura.rakennustieto.fi' },
    { label: 'Uutiset', href: 'https://uutiset.rakennustieto.fi' },
  ];
}
